import ProjeCard from '../components/ProjeCard'
import { projects } from '../static/data'

const Project = () => {
    return (
        <div className="container mx-auto my-10">
            <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-3xl xl:text-3xl 2xl:text-3xl 3xl:text-3xl font-bold mb-2">Tamamalanan Projelerimiz</h1>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {projects && projects?.map((e, i) => <ProjeCard proje={e} key={i} />)}
            </div>
            <h1 className="text-3xl font-bold mt-8">Muhtelif Konut Projeleri</h1>
        </div>
    )
}

export default Project
